/* eslint-disable no-shadow */
import { checkResponse, checkResponseErr, getProjectId } from '../utils'
import axios from '../axios'

const projectId = getProjectId() || 1

/**
 * @function getTreeTCase
 * @desc 典型案件左侧树形方法
 * @param {Number} projectId 项目id
 * @param {Number} typicalId 案例typicalId
 * @returns {Object} nodes 返回树节点信息
 * @returns {Number} nodes.parentId 父节点
 * @returns {String} nodes.label 节点名称
 * @returns {Number} nodes.value 节点id
 * @returns {Number} nodes.level 层级
 * @returns {Boolean} nodes.leaf 当前是否是叶子节点
 */
function getTreeTCase ({ typicalId }) {
  return axios
    .get(`/api/v1/projects/${projectId}/typicals/${typicalId}`)
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function batchAddTcaseTree
 * @desc 批量添加-添加同级，添加下一级 分类树方法
 * @param {Number} projectId 项目id
 * @param {Number} typicalId 案例typicalId
 * @param {Number} info 信息
 * @returns {Object} data 返回数据
 * @returns {String} data.titles 返回标题
 * @returns {Number} data.parent_id 返回父节点id
 * @returns {String} data.description 返回描述
 */
function batchAddTcaseTree (typicalId, info) {
  return axios
    .post(`/api/v1/projects/${projectId}/typicals/${typicalId}/nodes`, {
      data: info,
    })
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function delTcaseTree
 * @desc 典型案件-左侧树形删除接口方法
 * @param {Number} projectId 项目id
 * @param {Number} typicalId 案例typicalId
 * @param {Number} nodeId 节点id
 * @returns {String} message 是否删除成功
 */
function delTcaseTree (typicalId, nodeId) {
  return axios
    .delete(
      `/api/v1/projects/${projectId}/typicals/${typicalId}/nodes?node_id=${nodeId}`
    )
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function editTCaseTree
 * @desc 典型案件-左侧树形编辑题目方法
 * @param {Number} projectId 项目id
 * @param {Number} typicalId 案例typicalId
 * @param {Number} nodeId 节点id
 * @param {Number} info 节点信息
 * @returns {Object} data 返回数据
 * @returns {String} data.title 返回标题
 * @returns {Number} data.parent_id 返回父节点id
 * @returns {Object} data.description 返回描述
 */
function editTCaseTree ({ typicalId, nodeId }, info) {
  return axios
    .put(
      `/api/v1/projects/${projectId}/typicals/${typicalId}/nodes?node_id=${nodeId}`,
      { data: info }
    )
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function getTcaseList
 * @desc 每个末级下案例列表方法
 * @param {Number} projectId 项目id
 * @param {Number} nodeId 节点id
 * @returns {Object} data 返回数据
 * @returns {Number} data.id 返回案例tnode_ucase_id
 * @returns {String} data.title 返回案例标题
 * @returns {String} data.description 返回案例描述
 * @returns {Object} data.images 返回案例图片
 * @returns {Number} data.ucase_id 返回案例案件来源ID
 * @returns {Number} data.sequence 返回案例顺序(数字越大越排在后边)
 */
function getTcaseList ({ nodeId }) {
  // projectId, nodeId
  return axios
    .get(
      `/api/v1/projects/${projectId}/tnode_ucases/tnode_list?tnode_id=${nodeId}`
    )
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function getTcaseTitle
 * @desc 三级案件分类标题及描述方法
 * @param {Number} projectId 项目id
 * @param {Number} typicalId 案例typicalId
 * @param {Number} nodeId 树节点id
 * @returns {Object} data 返回数据
 * @returns {String} data.doc_title 返回案件标题
 * @returns {String} data.description 返回案件描述
 */
function getTcaseTitle ({ typicalId, nodeId }) {
  return axios
    .get(
      `/api/v1/projects/${projectId}/typicals/${typicalId}/nodes?node_id=${nodeId}`
    )
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function editTcaseTitle
 * @desc 编辑put 三级案件分类标题及描述方法
 * @param {Number} projectId 项目id
 * @param {Number} typicalId 案例typicalId
 * @param {Number} nodeId 树节点id
 * @returns {Object} data 返回数据
 * @returns {String} data.doc_title 返回案件标题
 * @returns {String} data.description 返回案件描述
 */
function editTcaseTitle ({ typicalId, nodeId }, info) {
  return axios
    .put(
      `/api/v1/projects/${projectId}/typicals/${typicalId}/nodes?node_id=${nodeId}`,
      { data: info }
    )
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function listAddTCase
 * @desc 案件列表中将列表添加为典型案例方法
 * @param {Number} projectId 项目id
 * @param {Number} info 案件信息
 * @returns {String} message 返回信息
 */
function listAddTCase (info) {
  return axios
    .post(`/api/v1/projects/${projectId}/tnode_ucases`, { data: info })
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function tcaseEdit
 * @desc 典型案例编辑方法
 * @param {Number} projectId 项目id
 * @param {Number} tnodeUcasesId 案件id
 * @param {String} info 案件信息
 * @returns {String} message 返回信息
 */
function tcaseEdit (tnodeUcasesId, info) {
  return axios
    .put(`/api/v1/projects/${projectId}/tnode_ucases/${tnodeUcasesId}`, {
      data: info,
    })
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function getTypicalCaseInt
 * @desc 典型案例方法
 * @param {Number} projectId 项目id
 * @param {Number} tnodeUcasesId 案件id
 * @param 无
 * @returns {Object} data 返回数据
 * @returns {String} data.title 返回案例标题
 * @returns {String} data.description 返回案例描述
 * @returns {Object} data.images 返回案例图片
 * @returns {Number} data.ucase_id 返回案例id
 * @returns {Number} data.tnode_id 返回案例树形结构中末级ID
 */
function getTypicalCaseInt (tnodeUcasesId) {
  return axios
    .get(`/api/v1/projects/${projectId}/tnode_ucases/${tnodeUcasesId}`)
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function tcaseDel
 * @desc 典型案例删除方法
 * @param {Number} projectId 项目id
 * @param {Number} tnodeUcasesId 案件id
 * @param {String} info 案件信息
 * @returns {String} message 返回信息
 */
function tcaseDel (typicalUcaseId) {
  return axios
    .delete(`/api/v1/projects/${projectId}/tnode_ucases/${typicalUcaseId}`)
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function typicalId
 * @desc 得到typical_id接口方法
 * @param {Number} projectId 项目id
 * @returns {Object} datas 返回信息
 * @returns {Number} datas.id  id
 * @returns {String} datas.name 名称
 */
function typicalId () {
  return axios
    .get(`/api/v1/projects/${projectId}/typicals`)
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function treeCase
 * @desc 移动典型案例列表中顺序方法
 * @param {Number} projectId 项目id
 * @param {Number} typical_ucase_id 案件id
 * @param {Object} sequence 返回数据
 * @param {Object} sequence.up 上移
 * @param {Object} sequence.down 下移
 */
// function caseOrder () {
//   return axios
//     .put(`/api/v1/projects/:project_id/tnode_ucases/sequence?{typical_ucase_id}`)
//     .then(checkResponse)
//     .catch(checkResponseErr)
// }

export {
  getTreeTCase,
  batchAddTcaseTree,
  delTcaseTree,
  editTCaseTree,
  getTcaseList,
  getTcaseTitle,
  editTcaseTitle,
  listAddTCase,
  tcaseEdit,
  getTypicalCaseInt,
  tcaseDel,
  typicalId
}
